export default "__VITE_ASSET__CnCaUx9k__"